export default {
  SET_LIST(state, list) {
    state.list = list;
  },
};
